import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  connect: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.connect`,
    defaultMessage: 'Connect',
  },
  connectToPartner: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.connectToPartner`,
    defaultMessage: 'Connect to {partnerName} to configure options',
  },
  integrationName: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.integrationName`,
    defaultMessage: '{partnerName} Integration',
  },
  manageIntegration: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.manageIntegration`,
    defaultMessage: 'Manage Integration',
  },
  mustBeConnected: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.mustBeConnected`,
    defaultMessage:
      'Must be connected to the partner integration, please connect.',
  },
  requireNewResult: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.requireNewResult`,
    defaultMessage: 'Wait for a new {partnerName} result',
    description:
      'Switch label: the stage ignores the partner result an applicant brought from an earlier stage and waits for the partner to run again',
  },
  requireNewResultDescription: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.requireNewResultDescription`,
    defaultMessage:
      "Clears the applicant's earlier {partnerName} result when they reach this stage, so the stage waits for {partnerName} to run again",
    description:
      'Helper text under the switch that makes a partner stage wait for a new partner result instead of reusing an earlier one',
  },
  refreshOptions: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.refreshOptions`,
    defaultMessage: 'Refresh options from {partnerName}',
  },
  stageOptionType: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.stageOptionType`,
    defaultMessage: 'Stage Option Type',
  },
  enableI9ComplianceCenterWidget: {
    id: `app.components.WorkflowEditorContent.StageDetail.PartnerStage.PartnerIntegrationCard.enableI9ComplianceCenterWidget`,
    defaultMessage: 'Enable I-9 Compliance Center support widget',
  },
});
